<template>
  <div class="app-container">
    <h3 style="padding-right:10px">{{ $t('invoice.summary') }}</h3>
    <div style="padding-bottom:30px">
      <label style="padding-right:10px">{{ $t('invoiceSummary.from') }}</label>
      <el-date-picker
        v-model="startDate"
        style="padding-right:10px"
        :disabled="loading"
        :clearable="false"
        :format="dateFormat"
        :value-format="dateValueFormat"
      ></el-date-picker>
      <label style="padding-right:10px">{{ $t('invoiceSummary.to') }}</label>
      <el-date-picker
        v-model="endDate"
        style="padding-right:10px"
        :disabled="loading"
        :clearable="false"
        :format="dateFormat"
        :value-format="dateValueFormat"
      ></el-date-picker>
      <editor-button
        :disabled="loading"
        button-translation="invoiceSummary.create"
        action="primary"
        :icon-only="false"
        style="padding-bottom:10px;"
        @click="createSummary()"
      />
    </div>
    <h3 style="padding-right:10px">{{ $t('invoice.details') }}</h3>
    <div>
      <label style="padding-right:10px">{{ $t('invoice.month') }}</label>
      <el-date-picker
        v-model="detailsMonth"
        style="padding-right:10px"
        :disabled="loading"
        type="month"
        :clearable="false"
        :value-format="dateValueFormat"
      ></el-date-picker>
      <editor-button
        :disabled="loading"
        button-translation="invoiceSummary.create"
        action="primary"
        :icon-only="false"
        style="padding-bottom:10px;"
        @click="createDetailed()"
      />
    </div>
    <div style="padding-bottom:10px"></div>
  </div>
</template>

<script>
import EditorButton from '@/components/crud/EditorButton';
import { ForceFileDownload } from '@/utils/general';
import { toDateString } from '@/utils/date';

export default {
  components: {
    EditorButton
  },
  data() {
    const today = new Date();
    return {
      loading: false,
      startDate: toDateString(new Date(today.getFullYear(), 0, 1)),
      endDate: toDateString(new Date(today.getFullYear(), today.getMonth(), today.getDate())),
      dateFormat: this.$store.getters.dateFormat,
      dateValueFormat: 'yyyy-MM-dd',
      detailsMonth: toDateString(today)
    };
  },
  methods: {
    createSummary() {
      this.loading = true;
      this.$store
        .dispatch('invoiceSummary/createSummary', {
          startDate: this.startDate,
          endDate: this.endDate
        })
        .then(blob => {
          ForceFileDownload(blob, `Invoice summary ${this.startDate} to ${this.endDate}.xlsx`);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createDetailed() {
      this.loading = true;
      this.$store
        .dispatch('invoiceSummary/createDetailed', {
          month: this.detailsMonth
        })
        .then(blob => {
          ForceFileDownload(blob, `Invoice report ${this.detailsMonth.substring(0, 7)}.xlsx`);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
